import API from '../../../constants/EnvConstants';
import callApi from "../../../utils/handleCallApi";
function* postCreateQaCategory(data) {
  const url = `${API.samuraiApiUrl}/qa_categories`;
  return yield callApi("post", url, data.data, data.accessToken, null, data.onSuccess, data.onError, data.onErrorWithNotice);
}
function* getIndexQaCategory(data) {
  const url = `${API.samuraiApiUrl}/qa_categories/`;
  return yield callApi("get", url, data.data, data.accessToken, data.data, data.onSuccess, data.onError, data.onErrorWithNotice);
}

function* getShowQaCategory(data) {
  const url = `${API.samuraiApiUrl}/qa_categories/${data.data.id}`;
  return yield callApi("get", url, data.data, data.accessToken, null, data.onSuccess, data.onError, data.onErrorWithNotice);
}

function* putUpdateQaCategory(data) {
  const url = `${API.samuraiApiUrl}/qa_categories/${data.data.id}`;
  return yield callApi("put", url, data.data, data.accessToken, null, data.onSuccess, data.onError, data.onErrorWithNotice);
}

function* deleteDeleteQaCategory(data) {
  const url = `${API.samuraiApiUrl}/qa_categories/${data.data.id}`;
  return yield callApi("delete", url, data.data, data.accessToken, null, data.onSuccess, data.onError, data.onErrorWithNotice);
}

export const Api = {
  postCreateQaCategory,
  getIndexQaCategory,
  getShowQaCategory,
  putUpdateQaCategory,
  deleteDeleteQaCategory
};
